module.exports = __webpack_public_path__ + "media/images/icon_list/home_filled-dc4c8305a70aeedd382a3db9f82f69b7.svg";